import "../../../assets/angular-components/klimatmodulen";

export default function DistrictHeatingClimateInfoAngular(params) {
  return (
    <div>
      <district-heating-system-component
        customer={params.customer}
        district={params.district}
        building={params.building}
        economic={params.economicProfile}
        api={params.api}
      />
    </div>
  );
}
